<template>
  <div>
    <el-button @click="getClipsboard" id="get_data_btn">获取最新的文章</el-button>
    <el-button @click="copyToClipboard" id="copy_data_btn">拷贝到剪贴板</el-button>
<!--    <p>剪贴板内容: {{ clipboardText }}</p>-->

    <el-row>
      <el-table
          ref="dataTable"
          :data="wechatDetails"
          style="width: 100%"
      >
<!--        <el-table-column type="selection" width="55"> </el-table-column>-->
<!--        <el-table-column prop="_id" label="主键"> </el-table-column>-->
        <el-table-column prop="authorName" label="公众号名称"> </el-table-column>
        <el-table-column prop="wechatUnqueId" label="公众号ID"> </el-table-column>
        <el-table-column prop="title" label="标题">
        </el-table-column>
        <el-table-column prop="createTime" label="发布时间"> </el-table-column>
        <el-table-column prop="ipLocation" label="发布地"> </el-table-column>
      </el-table>

    </el-row>

  </div>
</template>

<script>
export default {
  data() {
    return {
      clipboardText: '',
      wechatDetails: []
    };
  },
  methods: {
    getClipsboard() {
      navigator.clipboard.readText()
          .then(text => {
            this.clipboardText = text;
            if(text.length > 12 && text.indexOf('wetchat_details_list:') === 0) {
              const iTexts = text.replace('wetchat_details_list:','');
              console.log(iTexts);
              this.wechatDetails = JSON.parse(iTexts);

            }
          })
          .catch(err => {
            console.error('无法读取剪贴板内容:', err);
          });
    },
    copyToClipboard() {
      let datas = [];
      // console.log('dsfsds')
      for(let i = 0;i< this.wechatDetails.length;i++ ){
        let art = this.wechatDetails[i];
        const values = Object.values(art);
        const csvValues = values.join('\t');
        datas.push(csvValues);
      }
      this.wechatDetails = [];
      // console.log(datas.join('\n'))
      navigator.clipboard.writeText(datas.join('\n'));
    }
  },
  mounted() {
  }
};
</script>